(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["assem-kids-featured"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('assem-featured')) return;
  const key = 'assem-kids-favorites-v1';
  let memory = [];
  let storageAvailable = true;
  const read = () => {
    if(!storageAvailable) return memory;
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      if(Array.isArray(data)) memory = data.filter(id => typeof id === 'string' && /^\d+$/.test(id));
    } catch {storageAvailable = false;}
    return memory;
  };
  customElements.define('assem-featured', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.labels = JSON.parse(this.querySelector('[data-favorites-config]').textContent);
      this.sync();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-favorite]');
        if(!button) return;
        event.preventDefault();
        const id = button.dataset.favorite;
        const saved = new Set(read());
        const removing = saved.has(id);
        if(removing) saved.delete(id); else saved.add(id);
        memory = [...saved];
        try {localStorage.setItem(key, JSON.stringify(memory));} catch {storageAvailable = false;}
        document.dispatchEvent(new CustomEvent('assem:favorites-changed'));
        this.querySelector('[data-favorites-status]').textContent = (removing ? this.labels.removed : this.labels.saved) + ': ' + button.dataset.productTitle;
      },{signal});
      document.addEventListener('assem:favorites-changed', () => this.sync(),{signal});
      window.addEventListener('storage', event => { if(event.key === key || event.key === null) this.sync(); },{signal});
    }
    sync() {
      const ids = new Set(read());
      this.querySelectorAll('[data-favorite]').forEach(button => {
        const saved = ids.has(button.dataset.favorite);
        button.hidden = false;
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', (saved ? this.labels.remove : this.labels.save) + ': ' + button.dataset.productTitle);
      });
    }
    disconnectedCallback() {this.controller?.abort();}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (!window.AssemCartBridge) {
    const bridge = window.AssemCartBridge = new EventTarget();
    const mutation = (value) => {
      try {
        const url = new URL(value, location.href);
        return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
      } catch { return false; }
    };
    const announce = (url) => bridge.dispatchEvent(new CustomEvent('mutation', {detail:{add:/\/add(\.js)?\/?(?:\?|$)/.test(url)}}));
    const nativeFetch = window.fetch;
    window.fetch = function(input, options) {
      const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
      const internal = new Headers(options?.headers || (input instanceof Request ? input.headers : undefined)).has('X-Assem-Internal');
      const promise = nativeFetch.apply(this, arguments);
      if (mutation(url) && !internal) promise.then(response => {
        if (response.ok) announce(url);
      }).catch(() => {});
      return promise;
    };
    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method,url) {
      this.akCartURL = String(url);
      return open.apply(this,arguments);
    };
    const send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      if (mutation(this.akCartURL)) this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) announce(this.akCartURL);
      }, {once:true});
      return send.apply(this,arguments);
    };
  }
  if (customElements.get('assem-header')) return;
  customElements.define('assem-header', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.config = JSON.parse(this.querySelector('[data-ak-config]').textContent);
      this.root = this.dataset.root.replace(/\/?$/, '/');
      this.mobile = matchMedia('(max-width:1099px)');
      this.nav = this.querySelector('.ak-navigation');
      this.cart = this.querySelector('[data-dialog=cart]');
      this.moveNav();
      this.initSticky(signal);
      this.initMenuHover(signal);
      this.mobile.addEventListener('change', () => this.moveNav(), {signal});
      this.addEventListener('click', event => this.click(event), {signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, {signal});
        dialog.addEventListener('close', () => this.closed(dialog), {signal});
      });
      this.querySelectorAll('.ak-navigation details').forEach(details => details.addEventListener('toggle', () => {
        if (details.open && !this.mobile.matches && details.classList.contains('ak-dropdown')) this.querySelectorAll('.ak-dropdown[open]').forEach(other => { if(other !== details) other.open = false; });
      }, {signal}));
      document.addEventListener('click', event => {
        if(!this.contains(event.target)) this.querySelectorAll('.ak-dropdown[open]').forEach(d => d.open = false);
      }, {signal});
      this.addEventListener('keydown', event => {
        if(event.key === 'Escape') this.querySelectorAll('.ak-dropdown[open]').forEach(d => d.open = false);
      }, {signal});
      if (this.dataset.observe === 'true') window.AssemCartBridge.addEventListener('mutation', event => {
        if (event.detail.add && this.dataset.autoOpen === 'true') this.open('cart');
        this.scheduleRefresh();
      }, {signal});
      ['cart:updated','cart:refresh','cart:change','product:added','assem:cart-refresh'].forEach(name => document.addEventListener(name, () => this.scheduleRefresh(), {signal}));
      window.addEventListener('pageshow', () => this.scheduleRefresh(), {signal});
      document.addEventListener('visibilitychange', () => { if(!document.hidden) this.scheduleRefresh(); }, {signal});
      this.scheduleRefresh();
      this.bindProductForms();
      customElements.whenDefined('product-form').then(() => { if(this.isConnected) this.bindProductForms(); });
      document.addEventListener('shopify:section:load', () => this.bindProductForms(), {signal});
      document.addEventListener('submit', () => this.bindProductForms(), {capture:true,signal});
    }
    initMenuHover(signal) {
      if (!this.nav) return;
      this.nav.querySelectorAll('details').forEach(details => {
        let closeTimer;
        const cancelClose = () => clearTimeout(closeTimer);
        const closeMenu = () => {
          cancelClose();
          closeTimer = setTimeout(() => {
            if (!this.mobile.matches && !details.matches(':hover') &&
                !details.contains(document.activeElement)) {
              details.open = false;
            }
          }, 160);
        };
        details.addEventListener('pointerenter', event => {
          if (this.mobile.matches || event.pointerType !== 'mouse') return;
          cancelClose();
          if (details.classList.contains('ak-dropdown')) {
            this.nav.querySelectorAll('.ak-dropdown[open]').forEach(other => {
              if (other !== details) other.open = false;
            });
          }
          details.open = true;
        }, {signal});
        details.addEventListener('pointerleave', event => {
          if (!this.mobile.matches && event.pointerType === 'mouse') closeMenu();
        }, {signal});
        details.addEventListener('focusin', cancelClose, {signal});
        details.addEventListener('focusout', event => {
          if (!this.mobile.matches && !details.contains(event.relatedTarget)) closeMenu();
        }, {signal});
        this.mobile.addEventListener('change', cancelClose, {signal});
        signal.addEventListener('abort', cancelClose, {once:true});
      });
    }
    bindProductForms() {
      if(this.dataset.productForms !== 'true') return;
      this.formBindings ||= new Map();
      const header = this;
      const adapter = {
        classList: header.cart.classList,
        getSectionsToRender: () => [{id:header.dataset.section}],
        setActiveElement: el => { header.returnFocus = el; },
        renderContents: () => { if(header.dataset.autoOpen === 'true') header.open('cart'); header.scheduleRefresh(); }
      };
      document.querySelectorAll('product-form').forEach(form => {
        if('cart' in form && !this.formBindings.has(form)) {
          this.formBindings.set(form, form.cart);
          form.cart = adapter;
        }
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.stickyObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
      this.stickySpacer?.remove();
      this.style.removeProperty("position");
      this.style.removeProperty("top");
      this.style.removeProperty("left");
      this.style.removeProperty("width");
      this.style.removeProperty("z-index");
      this.formBindings?.forEach((cart, form) => { form.cart = cart; });
      clearTimeout(this.timer);
      this.querySelectorAll('dialog[open]').forEach(d => d.close());
      this.unlock();
    }
    initSticky(signal) {
      if(this.dataset.sticky !== 'true') return;
      this.stickySpacer = document.createElement('div');
      this.stickySpacer.setAttribute('aria-hidden','true');
      this.stickySpacer.style.cssText = 'display:block;height:0;pointer-events:none;';
      this.before(this.stickySpacer);
      const offset = Number(this.dataset.stickyOffset) || 0;
      const update = () => {
        if(!this.isConnected) return;
        const anchor = this.stickySpacer.getBoundingClientRect();
        if(anchor.top <= offset) {
          const height = this.getBoundingClientRect().height;
          this.stickySpacer.style.height = height + 'px';
          this.style.setProperty('position','fixed','important');
          this.style.setProperty('top',offset + 'px','important');
          this.style.setProperty('left',anchor.left + 'px','important');
          this.style.setProperty('width',anchor.width + 'px','important');
          this.style.setProperty('z-index','1000','important');
        } else {
          this.stickySpacer.style.height = '0px';
          ['position','top','left','width','z-index'].forEach(p => this.style.removeProperty(p));
        }
      };
      const queue = () => {
        if(this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => { this.stickyFrame = 0; update(); });
      };
      window.addEventListener('scroll',queue,{passive:true,signal});
      window.addEventListener('resize',queue,{passive:true,signal});
      this.stickyObserver = new ResizeObserver(queue);
      this.stickyObserver.observe(this);
      this.stickyObserver.observe(this.parentElement);
      update();
    }
    moveNav() {
      if(!this.nav) return;
      this.querySelectorAll('.ak-dropdown[open]').forEach(d => d.open = false);
      (this.mobile.matches ? this.querySelector('.ak-menu-slot') : this.querySelector('.ak-nav-home')).append(this.nav);
      if(!this.mobile.matches) this.querySelector('[data-dialog=menu]').close();
    }
    click(event) {
      const trigger = event.target.closest('[data-open]');
      if(trigger) { event.preventDefault(); this.open(trigger.dataset.open,trigger); return; }
      if(event.target.closest('[data-close]')) { event.target.closest('dialog').close(); return; }
      const quantity = event.target.closest('[data-quantity]');
      if(quantity) { event.preventDefault(); this.change(quantity); }
    }
    open(name, trigger) {
      const dialog = this.querySelector(`[data-dialog="${name}"]`);
      if(!dialog || dialog.open) return;
      this.querySelectorAll('dialog[open]').forEach(d => d.close());
      this.unlock();
      this.returnFocus = trigger || document.activeElement;
      this.querySelectorAll(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded','true'));
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      dialog.showModal();
      if(name === 'cart') this.scheduleRefresh();
      if(name === 'search') dialog.querySelector('input')?.focus();
    }
    closed(dialog) {
      this.querySelectorAll(`[data-open="${dialog.dataset.dialog}"]`).forEach(b => b.setAttribute('aria-expanded','false'));
      if(!this.querySelector('dialog[open]')) { this.unlock(); if(this.returnFocus?.isConnected) this.returnFocus.focus(); }
    }
    unlock() { if(this.locked) { document.documentElement.style.overflow = this.previousOverflow || ''; this.locked = false; } }
    scheduleRefresh() {
      this.pending = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.refresh(), 70);
    }
    async refresh() {
      if(this.refreshing || this.changing || !this.isConnected) return;
      this.refreshing = true;
      this.pending = false;
      try {
        const response = await fetch(this.root + 'cart.js', {cache:'no-store',signal:this.abort.signal});
        if(!response.ok) throw new Error(this.config.error);
        const cart = await response.json();
        if(this.changing || this.pending) return;
        this.setCount(cart.item_count);
        if(this.cart.open) {
          const url = new URL(this.root, location.origin);
          url.searchParams.set('section_id',this.dataset.section);
          const result = await fetch(url, {cache:'no-store',signal:this.abort.signal});
          if(!result.ok) throw new Error(this.config.error);
          const html = await result.text();
          if(!this.changing && !this.pending) this.render(html);
        }
      } catch(error) {
        if(error.name !== 'AbortError' && this.cart.open) this.error(this.config.error);
      } finally {
        this.refreshing = false;
        if(this.pending && !this.changing && this.isConnected) this.scheduleRefresh();
      }
    }
    render(html) {
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const source = parsed.querySelector('assem-header [data-cart-body]');
      if(!source) throw new Error(this.config.error);
      const current = this.querySelector('[data-cart-body]');
      const active = document.activeElement;
      const key = active?.closest('[data-line-key]')?.dataset.lineKey;
      const targetQuantity = active?.dataset.quantity;
      const scroll = current.scrollTop;
      current.innerHTML = source.innerHTML;
      current.scrollTop = scroll;
      const count = parsed.querySelector('[data-cart-count]');
      if(count) this.setCount(Number(count.textContent));
      if(key) {
        const row = [...current.querySelectorAll('[data-line-key]')].find(r => r.dataset.lineKey === key);
        const button = row && [...row.querySelectorAll('button')].find(b => b.dataset.quantity === targetQuantity);
        (button || row?.querySelector('button') || this.cart.querySelector('[data-close]')).focus();
      }
    }
    setCount(count) {
      this.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.hidden = el.classList.contains('ak-badge') && this.config.hideZero && count === 0;
      });
      this.querySelector('[data-status]').textContent = this.config.updated.replace('[count]',String(count));
    }
    error(message) {
      const target = this.querySelector('[data-cart-error]');
      target.textContent = message;
      target.hidden = !message;
    }
    async change(button) {
      if(this.changing) return;
      const key = button.closest('[data-line-key]').dataset.lineKey;
      this.changing = true;
      this.pending = true;
      const body = this.querySelector('[data-cart-body]');
      body.setAttribute('aria-busy','true');
      body.querySelectorAll('button').forEach(b => b.disabled = true);
      this.error('');
      try {
        const response = await fetch(this.root + 'cart/change.js', {
          method:'POST',headers:{'Content-Type':'application/json','X-Assem-Internal':'1'},
          body:JSON.stringify({id:key,quantity:Number(button.dataset.quantity),sections:[this.dataset.section],sections_url:this.root}),signal:this.abort.signal
        });
        const data = await response.json();
        if(!response.ok || data.errors) throw new Error(typeof data.description === 'string' ? data.description : this.config.error);
        this.setCount(data.item_count);
        const html = data.sections?.[this.dataset.section];
        if(html) this.render(html);
        document.dispatchEvent(new CustomEvent('assem:cart-updated',{detail:{cart:data}}));
      } catch(error) { if(error.name !== 'AbortError') this.error(error.message || this.config.error); }
      finally {
        this.changing = false;
        body.removeAttribute('aria-busy');
        body.querySelectorAll('button').forEach(b => b.disabled = false);
        this.scheduleRefresh();
      }
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

(() => {
  if(customElements.get('assem-collection-card')) return;
  const key='assem-kids-favorites-v1';
  let memory=[];
  let storageAvailable=true;
  function readFavorites(){
    if(!storageAvailable) return memory;
    let raw;
    try {raw=localStorage.getItem(key);} catch {storageAvailable=false;return memory;}
    try {const value=JSON.parse(raw||'[]');memory=Array.isArray(value)?value.filter(id=>typeof id==='string'&&/^\d+$/.test(id)):[];} catch {memory=[];}
    return memory;
  }
  customElements.define('assem-collection-card',class extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const signal=this.controller.signal;
      this.button=this.querySelector('[data-akpc-favorite]');
      if(!this.button)return;
      this.labels=JSON.parse(this.querySelector('[data-akpc-labels]').textContent);
      this.sync();
      this.button.addEventListener('click',event=>{
        event.preventDefault();event.stopPropagation();
        const ids=new Set(readFavorites());const id=this.button.dataset.akpcFavorite;
        const removing=ids.has(id);if(removing)ids.delete(id);else ids.add(id);
        memory=[...ids];try{localStorage.setItem(key,JSON.stringify(memory));}catch{storageAvailable=false;}
        document.dispatchEvent(new CustomEvent('assem:favorites-changed'));
        this.querySelector('[data-akpc-status]').textContent=(removing?this.labels.removed:this.labels.saved)+': '+this.button.dataset.title;
      },{signal});
      document.addEventListener('assem:favorites-changed',()=>this.sync(),{signal});
      window.addEventListener('storage',event=>{if(event.key===key||event.key===null)this.sync();},{signal});
    }
    sync(){const saved=new Set(readFavorites()).has(this.button.dataset.akpcFavorite);this.button.hidden=false;this.button.setAttribute('aria-pressed',String(saved));this.button.setAttribute('aria-label',(saved?this.labels.remove:this.labels.save)+': '+this.button.dataset.title);}
    disconnectedCallback(){this.controller?.abort();}
  });
})();


(() => {
  if(customElements.get('assem-price-filter'))return;
  customElements.define('assem-price-filter',class extends HTMLElement{
    connectedCallback(){
      this.observer?.disconnect();
      this.install();
      this.observer=new MutationObserver(()=>this.install());
      this.observer.observe(this,{childList:true,subtree:true});
    }
    disconnectedCallback(){this.observer?.disconnect();}
    install(){
      const config=this.querySelector('[data-assem-price]');
      const native=this.querySelector('price-facet-component');
      if(!config||!native)return;
      const existing=this.querySelector('.assem-dual-price');
      if(existing&&this.signature===config.textContent)return;
      if(existing)existing.remove();
      this.signature=config.textContent;
      let data;try{data=JSON.parse(config.textContent);}catch{return;}
      if(!(data.max>0))return;
      const inputs=[...native.querySelectorAll('input[name]')];
      const lowInput=inputs.find(i=>i.name===data.minName);
      const highInput=inputs.find(i=>i.name===data.maxName);
      if(!lowInput||!highInput)return;
      const example=String(data.formatExample).replace(/<[^>]*>/g,'').trim();
      const match=example.match(/([.,])(\d{1,2})$/);
      const separator=match?match[1]:'.';const decimals=match?match[2].length:0;
      const step=decimals?Math.pow(10,2-decimals):100;
      const formatInput=value=>decimals?(value/100).toFixed(decimals).replace('.',separator):String(Math.round(value/100));
      let money;try{money=new Intl.NumberFormat(data.locale||document.documentElement.lang||'en',{style:'currency',currency:data.currency||'USD'});}catch{money=new Intl.NumberFormat('en',{style:'currency',currency:'USD'});}
      const wrapper=document.createElement('div');wrapper.className='assem-dual-price';
      const values=document.createElement('div');values.className='assem-dual-price__values';
      const lowLabel=document.createElement('output');const highLabel=document.createElement('output');values.append(lowLabel,highLabel);
      const track=document.createElement('div');track.className='assem-dual-price__track';
      const low=document.createElement('input');const high=document.createElement('input');
      [low,high].forEach(input=>{input.type='range';input.min='0';input.max=String(data.max);input.step=String(step);});
      low.value=String(data.low);high.value=String(data.high);
      low.setAttribute('aria-label',lowInput.getAttribute('aria-label')||data.minName);
      high.setAttribute('aria-label',highInput.getAttribute('aria-label')||data.maxName);
      track.append(low,high);wrapper.append(values,track);native.prepend(wrapper);
      const row=native.querySelector('.facets__inputs-wrapper');
      const highest=native.querySelector('.price-facet__highest-price');
      if(row){row.classList.add('assem-native-price-fields');row.hidden=true;}
      if(highest){highest.classList.add('assem-native-price-highest');highest.hidden=true;}
      const update=(changed,commit)=>{
        let min=Number(low.value),max=Number(high.value);
        if(min>max){if(changed===low){min=max;low.value=String(min);}else{max=min;high.value=String(max);}}
        lowLabel.textContent=money.format(min/100);highLabel.textContent=money.format(max/100);
        low.setAttribute('aria-valuetext',lowLabel.textContent);high.setAttribute('aria-valuetext',highLabel.textContent);
        low.setAttribute('aria-valuemax',String(max));high.setAttribute('aria-valuemin',String(min));
        track.style.setProperty('--low',(min/data.max*100)+'%');track.style.setProperty('--high',(max/data.max*100)+'%');
        low.style.zIndex=min===data.max?'2':'1';
        lowInput.value=min===0?'':formatInput(min);highInput.value=max===data.max?'':formatInput(max);
        if(commit)(changed===low?lowInput:highInput).dispatchEvent(new Event('change',{bubbles:true}));
      };
      [low,high].forEach(input=>{
        input.addEventListener('input',event=>{event.stopPropagation();update(input,false);});
        input.addEventListener('change',event=>{event.stopPropagation();update(input,true);});
      });
      update(null,false);
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
